import { Directive, effect, ElementRef, inject, input, OnDestroy, output, Renderer2 } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[unis-handle-keyboard-shortcut]',
  exportAs: 'unisHandleKeyboardShortcut',
  standalone: true,
})
export class KeyboardShortcutDirective implements OnDestroy {
  public readonly tooltipText = input.required<string>();
  public readonly keyboardEvent = input.required<string>();
  public readonly keyPressed = output<void>();

  private readonly _renderer = inject(Renderer2);
  private readonly _elementRef = inject(ElementRef);

  constructor() {
    effect(() => {
      this._unlistenRenderer();
      this._unlistenRenderer = this._renderer.listen('document', `keydown.${this.keyboardEvent()}`, this.onShortcutTyped.bind(this));

      this._renderer.setAttribute(this._elementRef.nativeElement, 'title', this.tooltipText());
    });
  }

  public ngOnDestroy(): void {
    this._unlistenRenderer();
  }

  private _unlistenRenderer: (() => void) = () => null;

  private onShortcutTyped(event: KeyboardEvent): void {
    event.preventDefault();
    this.keyPressed.emit();
  }
}
